import { useTranslation } from 'react-i18next';

import type { DistributionViewMode } from '../../hooks/usePersistedDistributionView';

interface Props {
  title: string;
  mode: DistributionViewMode;
  onModeChange: (mode: DistributionViewMode) => void;
  /** Isolates DOM ids / data attributes so the two dashboard cards never clash */
  instanceId: 'firmware' | 'deviceLocation';
}

export const DashboardDistributionCardHeader = ({
  title,
  mode,
  onModeChange,
  instanceId,
}: Props) => {
  const { t } = useTranslation();

  const groupLabel = t('dashboard.page.distributionView.toggleGroup', {
    defaultValue: 'Chart display format',
  });
  const idSuffix = instanceId;

  return (
    <div
      className="dashboard-distribution-card-header"
      data-distribution-card={instanceId}
    >
      <span className="dashboard-distribution-card-header__title">{title}</span>
      <div
        className="dashboard-distribution-card-header__toggles"
        id={`dashboard-distribution-toggles-${idSuffix}`}
        role="group"
        aria-label={groupLabel}
      >
        <button
          type="button"
          id={`dashboard-distribution-bars-${idSuffix}`}
          className={`dashboard-distribution-card-header__icon-btn${
            mode === 'bars' ? ' is-active' : ''
          }`}
          onClick={() => onModeChange('bars')}
          aria-pressed={mode === 'bars'}
          title={t('dashboard.page.distributionView.listTitle', {
            defaultValue: 'List with horizontal bars',
          })}
          aria-label={t('dashboard.page.distributionView.listTitle', {
            defaultValue: 'List with horizontal bars',
          })}
        >
          <i className="pi pi-bars dashboard-distribution-card-header__icon" aria-hidden />
        </button>
        <button
          type="button"
          id={`dashboard-distribution-pie-${idSuffix}`}
          className={`dashboard-distribution-card-header__icon-btn${
            mode === 'pie' ? ' is-active' : ''
          }`}
          onClick={() => onModeChange('pie')}
          aria-pressed={mode === 'pie'}
          title={t('dashboard.page.distributionView.pieTitle', { defaultValue: 'Pie chart' })}
          aria-label={t('dashboard.page.distributionView.pieTitle', { defaultValue: 'Pie chart' })}
        >
          <i className="pi pi-chart-pie dashboard-distribution-card-header__icon" aria-hidden />
        </button>
      </div>
    </div>
  );
};
